import { ActiviteVersCompetenceAvecPrioriteComponent } from "./ActiviteVersCompetenceAvecPriorite"



export const CompetenceBloquanteComponent = () => {
    return <ActiviteVersCompetenceAvecPrioriteComponent controllerNaming={"bloquante"} textNaming={"bloquante"} infoDiv={<> Voici la liste des comptétences bloquantes par activités présentes sur la plateforme.<br />
        Une compétence bloquante est une compétence qui doit être sur le cv pour que le matching soit calculé. <br />
        Voire la documentation de pocahontas pour plus d'information</>} />
   
}